var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50072 6.20343C10.8235 5.43825 12.359 5 14 5C18.6325 5 22.4476 8.50005 22.9451 13H21.1586C20.7047 13 20.441 13.512 20.7053 13.88L23.4967 17.7677C23.7191 18.0774 24.1809 18.0774 24.4033 17.7677L27.1947 13.88C27.459 13.512 27.1953 13 26.7414 13H24.9552C24.4499 7.3935 19.738 3 14 3C11.9981 3 10.1182 3.53569 8.49927 4.47222C8.02121 4.74876 7.85784 5.36049 8.13439 5.83855C8.41093 6.31661 9.02266 6.47997 9.50072 6.20343ZM3.04484 15H1.25854C0.804694 15 0.540974 14.488 0.805243 14.12L3.59669 10.2323C3.81911 9.92256 4.28086 9.92256 4.50328 10.2323L7.29472 14.12C7.55899 14.488 7.29527 15 6.84143 15H5.05492C5.55237 19.5 9.36744 23 14 23C15.6574 23 17.2074 22.5529 18.5392 21.7733C19.0158 21.4943 19.6284 21.6546 19.9074 22.1312C20.1864 22.6078 20.0262 23.2204 19.5495 23.4994C17.9196 24.4535 16.0221 25 14 25C8.26195 25 3.55007 20.6065 3.04484 15Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOutline);
export default __webpack_public_path__ + "static/media/switch_outline.384c96f6b84090cd52539dce48dc6560.svg";
export { ForwardRef as ReactComponent };